import React, { Component } from "react";
import { FormGroup, FormControl } from "react-bootstrap";

import icon from "../../../assets/images/resume-icon.svg";
import classNames from "classnames";
import styles from "./FileInput.scss";

class FileInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      placeholder: props.placeholder,
      showAsValid: true
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onReturn();
  }

  onReturn() {
    const value = this.props.input.value;
    if (typeof value === "string" && value !== "") {
      this.state.placeholder = value;
      this.state.showAsValid = true;
    }
  }

  onChange(e) {
    this.props.input.onChange(e.target.files[0]);

    // Break if there's no file selected
    let file = e.target.files[0];

    if (!file || !file.name) {
      return;
    }

    this.setState({ placeholder: file.name });

    this.props.onSelect(file.name);
  }

  onBlur(e) {
    this.props.input.onBlur(e.target.files[0]);
  }

  componentWillReceiveProps(nextProps) {
    const newValue = nextProps.input.value;

    if (
      this.props.input.value !== newValue &&
      typeof newValue === "string" &&
      newValue !== ""
    ) {
      this.setState({ placeholder: newValue, showAsValid: true });
    }
  }

  render() {
    const {
      input,
      name,
      placeholder,
      meta: { touched, error, warning, valid },
      ...props
    } = this.props;

    const validationState =
      (touched && valid && !error && this.state.showAsValid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    const feedback =
      this.state.placeholder === placeholder ? (
        <img
          src={icon}
          className={styles.icon}
          onClick={() => this.inputFileRef.click()}
        />
      ) : (
        <FormControl.Feedback className={styles.inputFeedback} />
      );

    const labelClass = classNames({
      [styles.labelFile]: true,
      [styles.labelFileName]: this.state.placeholder !== placeholder
    });

    return (
      <FormGroup validationState={validationState} className={styles.form}>
        <FormControl
          type="file"
          id={input.name}
          name={name}
          className={styles.inputFile}
          onChange={this.onChange}
          onBlur={this.onBlur}
          inputRef={ref => {
            this.inputFileRef = ref;
          }}
          {...props.input}
          {...props}
        />
        <label htmlFor={input.name} className={labelClass}>
          {this.state.placeholder}
        </label>
        {touched && error && <p className={styles.error}>{error}</p>}
        {feedback}
      </FormGroup>
    );
  }
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/common/fileInput/FileInput.js